import { onAuthStateChanged, signInAnonymously, type User } from 'firebase/auth';
import { useEffect, useState } from 'react';
import { auth } from '../../lib/firebase';

export type AuthState =
  | { status: 'loading'; user: null; error: null }
  | { status: 'authenticated'; user: User; error: null }
  | { status: 'error'; user: null; error: Error };

export function useAnonymousAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ status: 'loading', user: null, error: null });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        if (user) {
          setState({ status: 'authenticated', user, error: null });
        } else {
          signInAnonymously(auth).catch((error: Error) => {
            setState({ status: 'error', user: null, error });
          });
        }
      },
      (error) => {
        setState({ status: 'error', user: null, error });
      },
    );
    return unsubscribe;
  }, []);

  return state;
}
